export const weddingServices = [
  {
    id: 1,
    title: 'Diseño Personalizado',
    description: 'Creamos el vestido de tus sueños desde cero. Analizamos tu silueta, estilo y la temática de tu boda para diseñar una pieza única e irrepetible.',
    icon: 'ri-pencil-ruler-line',
  },
  {
    id: 2,
    title: 'Tejidos de Alta Gama',
    description: 'Trabajamos con sedas francesas, encajes de Chantilly, tul ilusión y organza italiana. Cada tejido es seleccionado personalmente para tu vestido.',
    icon: 'ri-scissors-cut-line',
  },
  {
    id: 3,
    title: 'Bordados Artesanales',
    description: 'Detalles en hilo de oro, perlas naturales, cristales Swarovski y aplicaciones florales hechas a mano. Cada bordado cuenta una historia.',
    icon: 'ri-vip-diamond-line',
  },
  {
    id: 4,
    title: 'Pruebas de Ajuste',
    description: 'Entre 3 y 5 sesiones de prueba a lo largo del proceso. Ajustamos cada centímetro para que el vestido se adapte perfectamente a tu cuerpo.',
    icon: 'ri-user-heart-line',
  },
];

export const weddingTestimonials = [
  {
    id: 1,
    name: 'María Elena García',
    role: 'Novia — Junio 2024',
    text: 'Anthony entendió perfectamente lo que quería: algo elegante pero moderno. El vestido fue absolutamente perfecto, todos quedaron maravillados. El proceso de pruebas fue muy cuidadoso.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Clara Fernández',
    role: 'Novia — Septiembre 2024',
    text: 'Llegué con una idea vaga y Anthony la convirtió en realidad. El bordado en la espalda era una obra de arte. Me sentí única en mi día. Totalmente recomendable.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Ana Beltrán',
    role: 'Novia — Mayo 2025',
    text: 'El nivel de detalle es impresionante. Cada puntada, cada pliegue está pensado. Además, el trato es exquisito: te sientes cuidada durante todo el proceso.',
    rating: 5,
  },
];

export const weddingFaqs = [
  {
    question: '¿Cuánto tiempo antes de la boda debo reservar cita?',
    answer: 'Recomendamos reservar con al menos 6-8 meses de antelación para vestidos de alta costura. Para diseños con bordados complejos o tejidos especiales, 10-12 meses es ideal. Así garantizamos tiempo suficiente para el proceso creativo y las pruebas de ajuste.',
  },
  {
    question: '¿Cuál es el precio de un vestido de novia de alta costura?',
    answer: 'Nuestros vestidos de novia parten desde 7.200€. El precio final depende del diseño, los tejidos seleccionados, el grado de bordado y los detalles ornamentales. Durante la primera consulta te presentamos un presupuesto detallado y transparente, sin compromiso.',
  },
  {
    question: '¿Puedo traer referencias o ideas de Pinterest?',
    answer: 'Por supuesto. Las referencias visuales son una excelente forma de comunicar tu visión. Anthony analizará cada detalle para crear algo único que combine tu inspiración con su expertise de diseñador.',
  },
  {
    question: '¿Incluye el vestido el velo o accesorios?',
    answer: 'El presupuesto del vestido incluye únicamente la prenda principal. Podemos diseñar a juego un velo, guantes o cinturón bordado como complementos adicionales. Todo se presupuesta de forma transparente.',
  },
  {
    question: '¿Trabajáis con novias internacionales?',
    answer: 'Sí, trabajamos con novias de toda España, Europa y América Latina. Coordinamos las sesiones de prueba en Barcelona durante visitas planificadas y ofrecemos consultas online para el seguimiento del diseño.',
  },
  {
    question: '¿Qué pasa si necesito una modificación de última hora?',
    answer: 'Incluimos una sesión de ajuste final aproximadamente 2 semanas antes de la boda. También ofrecemos servicio de arreglos urgentes si tu cuerpo cambia o necesitas alguna adaptación menor.',
  },
];

export const weddingProcess = [
  {
    step: 1,
    title: 'Consulta Inicial',
    description: 'Conversamos sobre tu visión, el estilo de la boda, tu silueta y presupuesto. Analizamos referencias y bocetamos las primeras ideas. Duración: 90 minutos.',
  },
  {
    step: 2,
    title: 'Diseño & Tejidos',
    description: 'Anthony presenta el boceto definitivo y seleccionamos juntos los tejidos. Firmamos el contrato y comenzamos el proceso creativo.',
  },
  {
    step: 3,
    title: 'Confección Artesanal',
    description: 'Cada pieza es confeccionada a mano en nuestro atelier. Los bordados se realizan artesanalmente, puntada a puntada, durante semanas.',
  },
  {
    step: 4,
    title: 'Pruebas de Ajuste',
    description: 'Entre 3 y 5 sesiones donde ajustamos la estructura, la caída de la falda y cada detalle para un ajuste perfecto.',
  },
  {
    step: 5,
    title: 'Entrega Final',
    description: 'Una última prueba dos semanas antes del gran día. Te entregamos el vestido enfundado, listo para brillar.',
  },
];